import ajaxHelperInstance from "@/lib/ajaxhelper";

export function API_GetSmsCaptcha(parameter, vueContext = undefined, spinName = 'spinning') {
    return ajaxHelperInstance.postM('/web/auth/getCodeLogin', parameter, vueContext, spinName)
}

export function API_GetSmsCaptchaWx(data, config = undefined, vueContext = undefined, spinName = "spinning") {
    return ajaxHelperInstance.get('/web/auth/getCodeWx', data, config, vueContext, spinName)
}


export function API_GetRegisterCaptcha(parameter, vueContext = undefined, spinName = 'spinning') {
    return ajaxHelperInstance.postM('/web/auth/getCode', parameter, vueContext, spinName)
}


export function API_CheckCode(parameter, vueContext = undefined, spinName = 'spinning') {
    return ajaxHelperInstance.postM('/web/auth/checkCode', parameter, vueContext, spinName)
}

export function API_Register(parameter, vueContext = undefined, spinName = 'spinning') {
    return ajaxHelperInstance.postM('/web/auth/register', parameter, vueContext, spinName)
}

export function API_ChangePassword(parameter, vueContext = undefined, spinName = 'spinning') {
    return ajaxHelperInstance.postM('/web/user/changePassword', parameter, vueContext, spinName)
}


